import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

type RuleNames =
  | 'contentHeaderText'
  | 'mainContent'
  | 'mainPaper';

const PREFIX = 'NoticePage';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      contentHeaderText: {
        fontFamily: theme.caslonDoric,
        fontWeight: 500,
        fontSize: '20px',
        color: theme.darkGreen,
      },
      mainContent: {
        margin: '32px auto',
        width: '1160px',
      },
      mainPaper: {
        marginTop: '22px',
        height: '635px',
        borderRadius: '10px',
        display: 'flex',
        '& .MuiPaper-root': {
          border: '1px solid rgba(224, 224, 224, 1)',
          borderRadius: '12px',
        },
        '& .MuiTableContainer-root': {
          height: '570px',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar': {
          width: '0.2em',
          backgroundColor: '#F5F5F5',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-thumb': {
          backgroundColor: '#000000',
          borderRadius: '10px',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555555',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-corner': {
          backgroundColor: '#F5F5F5',
        },
      },
    }
  ),
  { name: PREFIX },
);
